module.exports = __webpack_public_path__ + "static/media/happy.d21d5131.png";